import { render } from "./CallToActionRewardNew.vue?vue&type=template&id=1bd9d675&scoped=true"
import script from "./CallToActionRewardNew.vue?vue&type=script&lang=js"
export * from "./CallToActionRewardNew.vue?vue&type=script&lang=js"

import "./CallToActionRewardNew.vue?vue&type=style&index=0&id=1bd9d675&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd9d675"]])

export default __exports__